import DsAvatarBase from './DsAvatarBase.vue';
import DsAvatarIcon from './DsAvatarIcon.vue';
import DsAvatarInitials from './DsAvatarInitials.vue';
import DsAvatarBank from './DsAvatarBank.vue';

const DsAvatar = DsAvatarBase as typeof DsAvatarBase & {
    Icon: typeof DsAvatarIcon;
    Initials: typeof DsAvatarInitials;
    Bank: typeof DsAvatarBank;
};

DsAvatar.Icon = DsAvatarIcon;
DsAvatar.Initials = DsAvatarInitials;
DsAvatar.Bank = DsAvatarBank;

export { DsAvatar };
export default DsAvatar;
